module.exports = __webpack_public_path__ + "img/ax.e3e18061.svg";